@use "Styles/mixins";

:host {
    display: contents;
}

.vm-image-lightbox {
    &__surface {
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        touch-action: none;
    }

    &__image {
        max-width: 100vw;
        max-height: 100vh;
        max-height: 100dvh;
        object-fit: contain;
        user-select: none;
        transform-origin: center;
        will-change: transform;

        @include mixins.desktop-and-up {
            max-width: 90vw;
            max-height: 90vh;
            max-height: 90dvh;
        }
    }
}
